const reasons = [
  {
    icon: "ri-user-star-line",
    title: "遺品整理士が在籍",
    text: "遺品整理の資格を持つスタッフが在籍。故人様の思いを大切にしながら、丁寧に整理を進めます。",
  },
  {
    icon: "ri-shield-check-line",
    title: "貴重品を確実にお渡し",
    text: "通帳・印鑑・権利書・思い出の品は専用ケースに分類し、必ずご家族様へお渡しします。",
  },
  {
    icon: "ri-hand-heart-line",
    title: "供養・形見分けまで一貫対応",
    text: "仏壇・位牌などの供養品は提携寺院での合同供養に対応。形見分けの仕分けもお手伝いします。",
  },
  {
    icon: "ri-price-tag-3-line",
    title: "明朗会計・追加料金なし",
    text: "お見積り後の追加料金は一切いただきません。事前の写真見積りで安心の料金提示を行います。",
  },
];

export default function Reasons() {
  return (
    <section id="reasons" className="w-full py-20 md:py-28 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="text-center max-w-3xl mx-auto mb-10 md:mb-14">
          <p className="font-mincho text-primary-600 tracking-widest text-sm md:text-base mb-3">
            REASONS
          </p>
          <h2 className="text-3xl md:text-5xl font-bold text-foreground-950 leading-snug">
            京都の遺品整理が
            <br className="sm:hidden" />
            <span className="text-primary-500">選ばれる理由</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {reasons.map((r) => (
            <div
              key={r.title}
              className="bg-background-50 border border-background-200 rounded-lg p-6 md:p-7"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-100 mb-5">
                <i className={`${r.icon} text-primary-600 text-xl`}></i>
              </div>
              <h3 className="text-base md:text-lg font-bold text-foreground-900 mb-3">
                {r.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{r.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}